/**
 * Helper method that translates a id type character to a readable string
 *
 * @param idTypeString - The id type to evaluate
 */
export function identificationTypeString(idTypeString: string): string {
  switch (idTypeString) {
    case 'N':
      return 'Cédula';
    case 'P':
      return 'Pasaporte';
    case 'J':
      return 'Jurídica';
    default:
      return 'Otro';
  }
}

export function identificationNumberString(idTypeString: string): string {
  switch (idTypeString) {
    case 'J':
      return 'Número de RUC';
    case 'N': // fallthrough
    case 'P': // fallthrough
    default:
      return 'Número de identificación';
  }
}
